import { Injectable, Inject, Optional } from '@angular/core';
import { MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {

    constructor(@Optional() @Inject(MAT_DATE_LOCALE) matDateLocale?: string) {
        super(matDateLocale); // importante: fija this.locale
    }

    override getFirstDayOfWeek(): number {
        // Si quieres lunes para ES y domingo para EN usa esto
        // return this.locale?.startsWith('en') ? 0 : 1;
        return 1;
    }

    override getDayOfWeekNames(): string[] {
        // Devuelve "Dom/Lun..." en es, "Sun/Mon..." en en, etc.
        return Array.from({ length: 7 }, (_, i) => {
            // 2023-01-01 fue domingo; sumamos i para sacar todos
            const d = new Date(Date.UTC(2023, 0, 1 + i));
            return new Intl.DateTimeFormat(this.locale || 'es-ES', { weekday: 'short' }).format(d);
        });
    }

    override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
        const fmtStyle = style === 'narrow' ? 'narrow' : style; // Intl lo soporta tal cual
        return Array.from({ length: 12 }, (_, m) => {
            const d = new Date(Date.UTC(2023, m, 1));
            return new Intl.DateTimeFormat(this.locale || 'es-ES', { month: fmtStyle }).format(d);
        });
    }

    // override format(date: Date, displayFormat: unknown): string {
    //     // Para tu header "Mes de Año" en ES y "Month Year" en EN automáticamente
    //     const parts = new Intl.DateTimeFormat(this.locale || 'es-ES', {
    //         month: 'long',
    //         year: 'numeric',
    //     }).formatToParts(date);

    //     const month = parts.find(p => p.type === 'month')?.value ?? '';
    //     const year = parts.find(p => p.type === 'year')?.value ?? '';

    //     if ((this.locale || '').startsWith('es')) return `${month} de ${year}`;
    //     return `${month} ${year}`;
    // }

    override format(date: Date, displayFormat: unknown): string {
        // Aseguramos que la fecha es válida
        if (!(date instanceof Date) || isNaN(date.getTime())) return '';

        // Si el displayFormat indica que sólo queremos mes + año (header), devolvemos
        // el mes en mayúsculas y el año: "MARCH 2026".
        // Manejo algunos valores comunes de displayFormat que podría usar Angular Material.
        const monthYearKeys = new Set([
            'month',
            'monthYear',
            'monthYearLabel',
            'monthInput',
            'monthLabel',
            'header',
            'monthAndYear',
        ]);

        // `displayFormat` can be a string key or an object (e.g. {month: 'short', year: 'numeric'})
        // used by Angular Material's `MAT_DATE_FORMATS.display.monthYearLabel`.
        const isMonthYearObject = displayFormat && typeof displayFormat === 'object' &&
            'month' in (displayFormat as any) && 'year' in (displayFormat as any) && !('day' in (displayFormat as any));

        if ((typeof displayFormat === 'string' && monthYearKeys.has(displayFormat)) || isMonthYearObject) {
            // Usamos formatToParts para evitar literales como "de" en idiomas que los usan
            // (por ejemplo: "marzo de 2026"). Extraemos solo month y year y los juntamos
            // manualmente como "MES YYYY" en mayúsculas.
            const parts = new Intl.DateTimeFormat(this.locale || 'es-ES', {
                month: 'long',
                year: 'numeric',
            }).formatToParts(date);

            const month = parts.find(p => p.type === 'month')?.value ?? '';
            const year = parts.find(p => p.type === 'year')?.value ?? '';

            return `${month.toUpperCase()} ${year}`.trim();
        }

        // Formato por defecto para fechas completas: "March 26, 2026"
        return new Intl.DateTimeFormat('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        }).format(date);
    }
}